(function () {
  'use strict';

  var DELIVERY_PROP = 'Delivery by';
  var ADDON_PROP = 'Protect Your Purchase';
  var ADDON_SELECTIONS_KEY = 'easifyAddOnSelections';

  var TIERS = [
    { key: 'standard',  buffer: 3, prop: '_delivery_standard' },
    { key: 'expedited', buffer: 2, prop: '_delivery_expedited' },
    { key: 'express',   buffer: 1, prop: '_delivery_express' }
  ];
  var STANDARD_TIER = TIERS[0];

  var DELIVERY_MAP_ATTR = '_delivery_map';
  // Easify bundles move line properties onto the line item group, which the order
  // notification Liquid can't read, so the add-on label is mirrored per variant here.
  var ADDON_MAP_ATTR = '_addon_map';
  var MAP_ENTRY_SEP = '|';
  var MAP_FIELD_SEP = '~';
  var MAP_KEY_SEP = ':';

  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
                     'July', 'August', 'September', 'October', 'November', 'December'];

  function cutoffParts() {
    var raw = (window.DeliveryDateConfig && window.DeliveryDateConfig.cutoff) || '14:30';
    var match = /^(\d{1,2}):(\d{2})$/.exec(String(raw).trim());
    var hours = match ? parseInt(match[1], 10) : 14;
    var minutes = match ? parseInt(match[2], 10) : 30;
    if (isNaN(hours) || hours < 0 || hours > 23) hours = 14;
    if (isNaN(minutes) || minutes < 0 || minutes > 59) minutes = 30;
    return { hours: hours, minutes: minutes };
  }

  function beforeCutoff(hours, minutes) {
    var cutoff = cutoffParts();
    return hours < cutoff.hours || (hours === cutoff.hours && minutes < cutoff.minutes);
  }

  function toShopTime(date) {
    var timezone = (window.DeliveryDateConfig && window.DeliveryDateConfig.timezone) || 'America/Boise';
    try {
      return new Date(date.toLocaleString('en-US', { timeZone: timezone }));
    } catch (e) {
      return new Date(date.toLocaleString('en-US', { timeZone: 'America/Boise' }));
    }
  }

  function isWeekend(date) {
    return date.getDay() === 0 || date.getDay() === 6;
  }

  function cutoffCountdown() {
    var cutoff = cutoffParts();
    var now = toShopTime(new Date());

    var deadline = new Date(now.getTime());
    deadline.setHours(cutoff.hours, cutoff.minutes, 0, 0);

    if (!isWeekend(now) && now.getTime() < deadline.getTime()) {
      return toCountdown(deadline.getTime() - now.getTime());
    }

    var showAfterCutoff = window.DeliveryDateConfig && window.DeliveryDateConfig.countdownAfterCutoff;
    if (isWeekend(now) || !showAfterCutoff) return null;

    deadline.setDate(deadline.getDate() + 1);
    while (isWeekend(deadline)) deadline.setDate(deadline.getDate() + 1);
    return toCountdown(deadline.getTime() - now.getTime());
  }

  function toCountdown(diff) {
    if (diff <= 0) return null;
    var minutes = Math.floor(diff / 60000);
    return { hours: Math.floor(minutes / 60), minutes: minutes % 60 };
  }

  function formatCountdown(countdown) {
    var parts = [];
    if (countdown.hours > 0) parts.push(countdown.hours + (countdown.hours === 1 ? ' hour' : ' hours'));
    parts.push(countdown.minutes + (countdown.minutes === 1 ? ' min' : ' mins'));
    return 'Order within ' + parts.join(' ');
  }

  function renderCountdowns() {
    var hidden = window.DeliveryDateConfig && window.DeliveryDateConfig.showCountdown === false;
    var countdown = hidden ? null : cutoffCountdown();
    var text = countdown ? formatCountdown(countdown) : '';
    document.querySelectorAll('[data-delivery-countdown]').forEach(function (el) {
      el.textContent = text;
      el.style.display = text ? '' : 'none';
    });
  }

  function calculateProcessingDate(currentDate, daysToAdd) {
    if (isNaN(daysToAdd) || !(currentDate instanceof Date)) return '';

    var date = new Date(currentDate.getTime());
    var cst = toShopTime(date);
    var dayOfWeek = date.getDay();

    if (beforeCutoff(cst.getHours(), cst.getMinutes()) && daysToAdd > 1 && dayOfWeek !== 0 && dayOfWeek !== 6) {
      daysToAdd -= 1;
    }

    var added = 0;
    while (added < daysToAdd) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added++;
    }
    if (date.getDay() === 0) date.setDate(date.getDate() + 1);

    return DAY_NAMES[date.getDay()] + ', ' + MONTH_NAMES[date.getMonth()] + ' ' + date.getDate();
  }

  function parseDeliveryMeta(raw) {
    if (!raw) return null;
    try {
      var data = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (!data || !data.mainProduct) return null;
      var from = parseInt(data.mainProduct.from, 10);
      var to = parseInt(data.mainProduct.to, 10);
      if (isNaN(from) || isNaN(to) || to <= 0) return null;
      return { from: from, to: to, weeks: !!data.weeks };
    } catch (e) {
      return null;
    }
  }

  function parseStorefrontMetafields(node) {
    if (!node || !node.metafields) return null;
    var byKey = {};
    node.metafields.forEach(function (mf) { if (mf) byKey[mf.key] = mf.value; });
    var from = parseInt(byKey.mw_delivery_time_from, 10);
    var to = parseInt(byKey.mw_delivery_time_to, 10);
    if (isNaN(from) || isNaN(to) || to <= 0) return null;
    return { from: from, to: to, weeks: byKey.mw_delivery_time_use_in_weeks === 'true' };
  }

  function computeDaysToAdd(meta, buffer) {
    var avg = (meta.to + meta.from) / 2;
    return Math.round((meta.weeks ? avg * 7 : avg) + buffer);
  }

  function computeTierDates(meta, now) {
    var at = now || new Date();
    var dates = {};
    TIERS.forEach(function (tier) {
      dates[tier.key] = calculateProcessingDate(at, computeDaysToAdd(meta, tier.buffer));
    });
    return dates;
  }

  function setDate(container, selector, value) {
    container.querySelectorAll(selector).forEach(function (el) { el.textContent = value; });
  }

  function mountModalToBody(modal, container) {
    if (!modal || modal.dataset.deliveryModalMounted === 'true') return;
    modal.dataset.deliveryModalMounted = 'true';
    if (container && container.id) {
      modal.dataset.deliveryModalOwner = container.id;
    }
    document.body.appendChild(modal);
  }

  function removeOrphanedDeliveryModals() {
    document.querySelectorAll('body > [data-delivery-modal][data-delivery-modal-mounted="true"]').forEach(function (modal) {
      var ownerId = modal.dataset.deliveryModalOwner;
      if (ownerId && document.getElementById(ownerId)) return;
      modal.remove();
    });
  }

  function bindModal(container) {
    if (container.dataset.deliveryBound) return;
    container.dataset.deliveryBound = '1';

    var trigger = container.querySelector('[data-delivery-modal-trigger]');
    var modal = container.querySelector('[data-delivery-modal]');
    var close = container.querySelector('[data-delivery-modal-close]');
    if (!modal) return;

    mountModalToBody(modal, container);

    function open(e) {
      if (e) e.preventDefault();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('delivery-modal--open');
      document.body.classList.add('overflow-hidden');
      if (close) close.focus();
    }
    function hide() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('delivery-modal--open');
      document.body.classList.remove('overflow-hidden');
      if (trigger) trigger.focus();
    }

    if (trigger) trigger.addEventListener('click', open);
    if (close) close.addEventListener('click', hide);
    modal.addEventListener('click', function (e) { if (e.target === modal) hide(); });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && modal.classList.contains('delivery-modal--open')) hide();
    });
  }

  function initDeliveryDate() {
    removeOrphanedDeliveryModals();

    document.querySelectorAll('[data-delivery-container]').forEach(function (container) {
      var meta = parseDeliveryMeta(container.getAttribute('data-delivery-meta'));
      if (!meta) {
        container.style.display = 'none';
        return;
      }

      var dates = computeTierDates(meta);
      setDate(container, '[data-delivery-standard-date]', dates.standard);
      setDate(container, '[data-delivery-expedited-date]', dates.expedited);
      setDate(container, '[data-delivery-express-date]', dates.express);

      container.style.display = 'block';
      bindModal(container);
    });

    renderCountdowns();
    if (!window.deliveryCountdownTimer) {
      window.deliveryCountdownTimer = setInterval(renderCountdowns, 30000);
    }
  }

  function injectDeliveryDateIntoProductForms() {
    document.querySelectorAll('[data-delivery-container]').forEach(function (container) {
      var meta = parseDeliveryMeta(container.getAttribute('data-delivery-meta'));
      if (!meta) return;

      var dates = computeTierDates(meta);
      if (!dates[STANDARD_TIER.key]) return;

      var scope = container.closest('product-info') || container.closest('.product') ||
                  container.closest('section') || document;
      var forms = scope.querySelectorAll('product-form form');
      if (!forms.length) forms = document.querySelectorAll('product-form form');

      var fields = [{ prop: DELIVERY_PROP, value: dates[STANDARD_TIER.key] }];
      TIERS.forEach(function (tier) {
        if (dates[tier.key]) fields.push({ prop: tier.prop, value: dates[tier.key] });
      });

      forms.forEach(function (form) {
        fields.forEach(function (field) {
          var name = 'properties[' + field.prop + ']';
          var input = form.querySelector('input[name="' + name + '"]');
          if (input) {
            input.value = field.value;
            return;
          }
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = field.value;
          form.appendChild(input);
        });
      });
    });
  }

  function getSectionInnerHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function getCartSectionsToRender() {
    var sections = [];
    var mainCart = document.getElementById('main-cart-items');
    if (mainCart && mainCart.dataset.id) {
      sections.push({ id: 'main-cart-items', section: mainCart.dataset.id, selector: '.js-contents' });
    }
    if (document.getElementById('CartDrawer')) {
      sections.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    }
    if (document.getElementById('cart-icon-bubble')) {
      sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }
    return sections;
  }

  function applyCartSections(rendered, sections) {
    if (!rendered) return;
    sections.forEach(function (s) {
      var html = rendered[s.section];
      var container = document.getElementById(s.id);
      if (!html || !container) return;
      var inner = getSectionInnerHTML(html, s.selector);
      if (inner == null) return;
      (container.querySelector(s.selector) || container).innerHTML = inner;
    });
  }

  function refreshCartSections() {
    var sections = getCartSectionsToRender();
    if (!sections.length) return;
    var param = sections.map(function (s) { return s.section; }).join(',');
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var join = cartUrl.indexOf('?') === -1 ? '?' : '&';
    return fetch(cartUrl + join + 'sections=' + encodeURIComponent(param))
      .then(function (r) { return r.json(); })
      .then(function (rendered) { applyCartSections(rendered, sections); })
      .catch(function () {});
  }

  function metafieldsQuery(handles) {
    var fields = handles.map(function (handle, i) {
      return 'p' + i + ': product(handle: ' + JSON.stringify(handle) + ') {' +
        ' metafields(identifiers: [' +
        '{namespace: "custom", key: "mw_delivery_time_from"},' +
        '{namespace: "custom", key: "mw_delivery_time_to"},' +
        '{namespace: "custom", key: "mw_delivery_time_use_in_weeks"}' +
        ']) { key value } }';
    });
    return '{' + fields.join(' ') + '}';
  }

  function setCheckoutGate(disabled) {
    if (!window.DeliveryDateConfig || !window.DeliveryDateConfig.gateCheckout) return;
    document.querySelectorAll('.cart__checkout-button').forEach(function (button) {
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
  }

  function syncCartDeliveryDates() {
    var cfg = window.DeliveryDateConfig;
    if (!cfg || !cfg.enabled || !cfg.token) return;
    if (window.deliveryDateSyncing) return;
    window.deliveryDateSyncing = true;
    setCheckoutGate(true);

    function release() { window.deliveryDateSyncing = false; setCheckoutGate(false); }

    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) return;

        var metaByHandle = {};
        items.forEach(function (item) {
          if (item.handle) metaByHandle[item.handle] = null;
        });
        var handles = Object.keys(metaByHandle);

        function patchCart() {
          var changes = [];
          items.forEach(function (item) {
            var meta = metaByHandle[item.handle];
            if (!meta) return;
            var dates = computeTierDates(meta);
            if (!dates[STANDARD_TIER.key]) return;

            var existing = item.properties || {};
            var desired = { };
            desired[DELIVERY_PROP] = dates[STANDARD_TIER.key];
            TIERS.forEach(function (tier) {
              if (dates[tier.key]) desired[tier.prop] = dates[tier.key];
            });

            var stale = Object.keys(desired).some(function (key) {
              return existing[key] !== desired[key];
            });
            if (!stale) return;

            var properties = Object.assign({}, existing, desired);
            changes.push({ id: item.key, quantity: item.quantity, properties: properties });
          });
          if (!changes.length) return syncDeliveryMapAttribute(items, cart.attributes);

          var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
          var chain = changes.reduce(function (promise, change) {
            return promise.then(function () {
              return fetch(changeUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: change.id, quantity: change.quantity, properties: change.properties }),
                keepalive: true
              }).catch(function () {});
            });
          }, Promise.resolve());

          return chain
            .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
            .then(function (fresh) {
              return syncDeliveryMapAttribute(fresh.items, fresh.attributes);
            })
            .catch(function () {})
            .then(refreshCartSections);
        }

        if (!handles.length) return;

        return fetch('https://' + cfg.shopDomain + '/api/' + (cfg.apiVersion || '2024-10') + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': cfg.token
          },
          body: JSON.stringify({ query: metafieldsQuery(handles) })
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            var data = response.data || {};
            handles.forEach(function (handle, i) {
              metaByHandle[handle] = parseStorefrontMetafields(data['p' + i]);
            });
            return patchCart();
          });
      })
      .then(release, release);
  }

  function buildDeliveryMap(items) {
    var seen = {};
    var entries = [];

    (items || []).forEach(function (item) {
      var id = item && item.variant_id;
      if (!id || seen[id]) return;

      var props = item.properties || {};
      var parts = TIERS.map(function (tier) {
        var value = props[tier.prop];
        return typeof value === 'string' ? value : '';
      });
      if (!parts.some(Boolean)) return;

      seen[id] = true;
      entries.push(id + MAP_KEY_SEP + parts.join(MAP_FIELD_SEP));
    });

    return entries.join(MAP_ENTRY_SEP);
  }

  function syncDeliveryMapAttribute(items, existingAttributes) {
    var desired = buildDeliveryMap(items);
    var current = (existingAttributes || {})[DELIVERY_MAP_ATTR] || '';
    if (desired === current) return;

    var payload = { attributes: {} };
    payload.attributes[DELIVERY_MAP_ATTR] = desired;

    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).catch(function () {});
  }

  // Keyed by variant + ring size, since ring sizes share one variant. Only lines with
  // `_po:items:addon` are bundled by Easify; other lines keep the property themselves.
  function addOnMapKey(variantId, ringSize) {
    return variantId + MAP_FIELD_SEP + String(ringSize || '').replace(/[|:~]/g, ' ');
  }

  function buildAddOnMap(items) {
    var seen = {};
    var entries = [];

    (items || []).forEach(function (item) {
      var props = (item && item.properties) || {};
      var label = props[ADDON_PROP];
      if (!item || !item.variant_id || !props['_po:items:addon'] || typeof label !== 'string' || !label) return;

      var key = addOnMapKey(item.variant_id, props['Ring Size'] || props['_Ring Size']);
      if (seen[key]) return;

      seen[key] = true;
      entries.push(key + MAP_KEY_SEP + label.replace(/\|/g, ' '));
    });

    return entries.join(MAP_ENTRY_SEP);
  }

  function syncAddOnMapAttribute(items, existingAttributes) {
    var desired = buildAddOnMap(items);
    var current = (existingAttributes || {})[ADDON_MAP_ATTR] || '';
    if (desired === current) return;

    var payload = { attributes: {} };
    payload.attributes[ADDON_MAP_ATTR] = desired;

    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).catch(function () {});
  }

  function formatAddOnPrice(cents, currency) {
    var amount = cents / 100;
    try {
      return amount.toLocaleString('en-US', { style: 'currency', currency: currency || 'USD' });
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function getAddOnLabel(item, items, currency) {
    var props = item.properties || {};
    var addOns;
    try {
      addOns = [JSON.parse(props['_po:items:addon'])].flat(Infinity);
    } catch (e) {
      return null;
    }

    var labels = [];
    addOns.forEach(function (addOn) {
      if (!addOn || !addOn.variantId) return;
      var optionValue = (addOn.properties || []).find(function (p) { return p.key === '_tpo_option_value_id'; });
      var line = items.find(function (other) {
        if (other === item || String(other.variant_id) !== String(addOn.variantId)) return false;
        if (!optionValue) return true;
        return String((other.properties || {})._tpo_option_value_id) === String(optionValue.value);
      });
      if (!line) return;
      var label = line.product_title + ' (' + formatAddOnPrice(line.price, currency) + ')';
      if (labels.indexOf(label) === -1) labels.push(label);
    });
    return labels.join(', ');
  }

  var ADDON_SELECTION_MAX_AGE = 7 * 24 * 60 * 60 * 1000;

  function readAddOnSelections() {
    var selections = {};
    try {
      var stored = JSON.parse(sessionStorage.getItem(ADDON_SELECTIONS_KEY)) || {};
      Object.keys(stored).forEach(function (fingerprint) {
        var entry = stored[fingerprint];
        if (entry && entry.label && Date.now() - entry.at < ADDON_SELECTION_MAX_AGE) selections[fingerprint] = entry;
      });
    } catch (e) {}
    return selections;
  }

  function writeAddOnSelections(selections) {
    try {
      if (Object.keys(selections).length) sessionStorage.setItem(ADDON_SELECTIONS_KEY, JSON.stringify(selections));
      else sessionStorage.removeItem(ADDON_SELECTIONS_KEY);
    } catch (e) {}
  }

  function lineFingerprint(item) {
    var props = item.properties || {};
    var stable = {};
    Object.keys(props).sort().forEach(function (key) {
      if (key === ADDON_PROP || key === DELIVERY_PROP) return;
      if (TIERS.some(function (tier) { return tier.prop === key; })) return;
      stable[key] = props[key];
    });
    return item.variant_id + ':' + JSON.stringify(stable);
  }

  function findVariantId(element) {
    if (element.closest('dialog')) return null;
    for (var node = element.parentElement; node; node = node.parentElement) {
      var idInput = node.querySelector('form[action*="/cart/add"] [name="id"]');
      if (idInput && idInput.value) return idInput.value;
    }
    return null;
  }

  function captureUnpricedAddOnSelections() {
    var selections = {};
    document.querySelectorAll('.po-option-root').forEach(function (group) {
      var groupLabel = group.querySelector('.po-label-label');
      if (!groupLabel || groupLabel.textContent.replace(/\*/g, '').trim() !== ADDON_PROP) return;
      var variantId = findVariantId(group) || '*';

      group.querySelectorAll('input.po-checkboxOption-checkbox:checked').forEach(function (checkbox) {
        var option = checkbox.closest('.po-checkboxOption-option') || checkbox.parentElement;
        var label = option && option.querySelector('.po-optionItemLabel-label');
        if (!label) return;
        var price = label.querySelector('.po-optionItemLabel-price');
        if (price && /[1-9]/.test(price.textContent)) return;
        var name = (price ? label.textContent.replace(price.textContent, '') : label.textContent)
          .replace(/\s+/g, ' ')
          .trim();
        if (name) selections[variantId] = name;
      });
    });
    return selections;
  }

  function rememberAddOnSelections(selections, addedItems) {
    if (!selections || !addedItems || !addedItems.length) return;
    var stored = readAddOnSelections();
    var changed = false;
    addedItems.forEach(function (item) {
      var label = selections[String(item.variant_id)] || selections['*'];
      if (!label || (item.properties || {})['_po:items:addon']) return;
      stored[lineFingerprint(item)] = { label: label, at: Date.now() };
      changed = true;
    });
    if (changed) writeAddOnSelections(stored);
  }

  function withAddOnProperty(props, label) {
    var deliveryKeys = [DELIVERY_PROP].concat(TIERS.map(function (tier) { return tier.prop; }));
    var properties = {};
    Object.keys(props).forEach(function (key) {
      if (key === ADDON_PROP || deliveryKeys.indexOf(key) !== -1) return;
      properties[key] = props[key];
    });
    if (label) properties[ADDON_PROP] = label;
    deliveryKeys.forEach(function (key) {
      if (key in props) properties[key] = props[key];
    });
    return properties;
  }

  var addOnSyncRetryTimer = null;
  function syncAddOnProperties() {
    if (window.addOnPropertySyncing || window.deliveryDateSyncing || window.deliveryDateReverting) {
      clearTimeout(addOnSyncRetryTimer);
      addOnSyncRetryTimer = setTimeout(syncAddOnProperties, 500);
      return;
    }
    window.addOnPropertySyncing = true;

    function release() { window.addOnPropertySyncing = false; }

    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var changes = [];
        var selections = readAddOnSelections();
        items.forEach(function (item) {
          var props = item.properties || {};
          if (props['_po:mainItemKey']) return;

          var label;
          if (props['_po:items:addon']) {
            label = getAddOnLabel(item, items, cart.currency);
          } else {
            var fingerprint = lineFingerprint(item);
            label = selections[fingerprint] ? selections[fingerprint].label : undefined;
          }
          if (label == null) return;

          var properties = withAddOnProperty(props, label);
          if (JSON.stringify(properties) === JSON.stringify(props)) return;
          changes.push({ id: item.key, quantity: item.quantity, properties: properties });
        });

        writeAddOnSelections(selections);
        if (!changes.length) return syncAddOnMapAttribute(items, cart.attributes);

        var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
        return changes.reduce(function (promise, change) {
          return promise.then(function () {
            return fetch(changeUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: change.id, quantity: change.quantity, properties: change.properties })
            }).catch(function () {});
          });
        }, Promise.resolve())
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (fresh) {
            return syncAddOnMapAttribute(fresh.items, fresh.attributes);
          })
          .catch(function () {})
          .then(refreshCartSections);
      })
      .catch(function () {})
      .then(release, release);
  }

  function revertCartToStandardDates() {

    if (window.deliveryDateReverting) return Promise.resolve();
    window.deliveryDateReverting = true;

    function release() { window.deliveryDateReverting = false; }

    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) return;

        var changes = [];
        items.forEach(function (item) {
          var props = item.properties || {};
          var standard = props[STANDARD_TIER.prop];
          if (!standard) return;
          if (props[DELIVERY_PROP] === standard) return;

          var properties = Object.assign({}, props);
          properties[DELIVERY_PROP] = standard;
          changes.push({ id: item.key, quantity: item.quantity, properties: properties });
        });

        if (!changes.length) return;

        var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
        return changes.reduce(function (promise, change) {
          return promise.then(function () {
            return fetch(changeUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: change.id,
                quantity: change.quantity,
                properties: change.properties
              })
            }).catch(function () {});
          });
        }, Promise.resolve()).then(refreshCartSections);
      })
      .catch(function () {})
      .then(release, release);
  }

  function refresh() {
    initDeliveryDate();
    injectDeliveryDateIntoProductForms();
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    refresh();
    revertCartToStandardDates()
      .then(syncCartDeliveryDates, syncCartDeliveryDates)
      .then(syncAddOnProperties, syncAddOnProperties);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(refresh, 0);
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      scheduleCartSync();
    });
  }

  var cartSyncTimer = null;
  function scheduleCartSync(delay) {
    clearTimeout(cartSyncTimer);
    cartSyncTimer = setTimeout(function () {
      initDeliveryDate();
      revertCartToStandardDates()
        .then(syncCartDeliveryDates, syncCartDeliveryDates)
        .then(syncAddOnProperties, syncAddOnProperties);
    }, delay || 0);
  }

  function getCartRequestType(url) {
    var match = String(url || '').match(/\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/);
    return match ? match[1] : null;
  }

  function isOwnCartSyncRunning() {
    return !!(window.deliveryDateSyncing || window.deliveryDateReverting || window.addOnPropertySyncing);
  }

  function getAddedItems(data) {
    if (!data) return [];
    if (Array.isArray(data.items)) return data.items;
    return data.variant_id ? [data] : [];
  }

  function onCartAdded(selections, data) {
    rememberAddOnSelections(selections, getAddedItems(data));
    scheduleCartSync(300);
  }

  var MAX_CHANGE_SYNCS = 3;
  var changeSyncCount = 0;
  var changeSyncResetTimer = null;
  function onCartChanged() {
    clearTimeout(changeSyncResetTimer);
    changeSyncResetTimer = setTimeout(function () { changeSyncCount = 0; }, 10000);
    if (changeSyncCount >= MAX_CHANGE_SYNCS) return;
    changeSyncCount += 1;
    scheduleCartSync(300);
  }

  if (typeof window.fetch === 'function' && !window.fetch.deliveryDateWatched) {
    var originalFetch = window.fetch;
    var watchedFetch = function (input) {
      var url = input && typeof input === 'object' && 'url' in input ? input.url : input;
      var type = getCartRequestType(url);
      if (type !== 'add' && isOwnCartSyncRunning()) type = null;
      var selections = type === 'add' ? captureUnpricedAddOnSelections() : null;
      var request = originalFetch.apply(this, arguments);
      if (type) {
        request.then(function (response) {
          if (!response.ok) return;
          if (type !== 'add') return onCartChanged();
          response
            .clone()
            .json()
            .then(function (data) { onCartAdded(selections, data); }, function () { onCartAdded(); });
        }, function () {});
      }
      return request;
    };
    watchedFetch.deliveryDateWatched = true;
    window.fetch = watchedFetch;
  }

  if (window.XMLHttpRequest && !XMLHttpRequest.prototype.deliveryDateWatched) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.deliveryDateCartRequest = getCartRequestType(url);
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var type = xhr.deliveryDateCartRequest;
      if (type !== 'add' && isOwnCartSyncRunning()) type = null;
      if (type) {
        var selections = type === 'add' ? captureUnpricedAddOnSelections() : null;
        xhr.addEventListener('load', function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          if (type !== 'add') return onCartChanged();
          var data = null;
          try {
            data = xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText);
          } catch (e) {}
          onCartAdded(selections, data);
        });
      }
      return originalSend.apply(this, arguments);
    };
    XMLHttpRequest.prototype.deliveryDateWatched = true;
  }

  document.addEventListener('product-info:loaded', function () {
    setTimeout(refresh, 0);
  });

  window.DeliveryDate = window.DeliveryDate || {};
  window.DeliveryDate.refresh = refresh;
})();
